import { createContext, useContext, useState } from 'react';
import { EMPTY_RESUME } from '../constants/sampleData';

const ResumeContext = createContext(null);

export function ResumeProvider({ children }) {
  const [data, setData] = useState(EMPTY_RESUME);
  const [rawText, setRawText] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState('corporate-boardroom');
  const [activeCategory, setActiveCategory] = useState('corporate');
  const [parseError, setParseError] = useState(null);
  const [accentOverrides, setAccentOverrides] = useState({});

  const setAccent = (color) => {
    setAccentOverrides(prev => ({
      ...prev,
      [selectedTemplate]: { ...(prev[selectedTemplate] || {}), accent: color },
    }));
  };

  const setAccent2 = (color) => {
    setAccentOverrides(prev => ({
      ...prev,
      [selectedTemplate]: { ...(prev[selectedTemplate] || {}), accent2: color },
    }));
  };

  const resetAccent = () => {
    setAccentOverrides(prev => {
      const next = { ...prev };
      delete next[selectedTemplate];
      return next;
    });
  };

  const resetAll = () => {
    setData(EMPTY_RESUME);
    setRawText('');
    setParseError(null);
  };

  const value = {
    data,
    setData,
    rawText,
    setRawText,
    selectedTemplate,
    setSelectedTemplate,
    activeCategory,
    setActiveCategory,
    parseError,
    setParseError,
    accentOverrides,
    setAccent,
    setAccent2,
    resetAccent,
    resetAll,
  };

  return (
    <ResumeContext.Provider value={value}>
      {children}
    </ResumeContext.Provider>
  );
}

export function useResume() {
  const ctx = useContext(ResumeContext);
  if (!ctx) throw new Error('useResume must be used within ResumeProvider');
  return ctx;
}
